var _excluded = ["viewBox"];
function cov_h3t7s5ll0() {
  var path = "/app/src/components/logo/components/logo-en-green-on-black/logo-en-green-on-black.tsx";
  var hash = "0b949f0e8718ae3c07853529eee99f8c40e149bf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-green-on-black/logo-en-green-on-black.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 34
        },
        end: {
          line: 154,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 22
        },
        end: {
          line: 10,
          column: 54
        }
      },
      "2": {
        start: {
          line: 11,
          column: 22
        },
        end: {
          line: 11,
          column: 54
        }
      },
      "3": {
        start: {
          line: 12,
          column: 22
        },
        end: {
          line: 12,
          column: 54
        }
      },
      "4": {
        start: {
          line: 13,
          column: 22
        },
        end: {
          line: 13,
          column: 54
        }
      },
      "5": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 14,
          column: 54
        }
      },
      "6": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 15,
          column: 54
        }
      },
      "7": {
        start: {
          line: 16,
          column: 22
        },
        end: {
          line: 16,
          column: 54
        }
      },
      "8": {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 17,
          column: 54
        }
      },
      "9": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 153,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 34
          },
          end: {
            line: 6,
            column: 35
          }
        },
        loc: {
          start: {
            line: 9,
            column: 17
          },
          end: {
            line: 154,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 24
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0b949f0e8718ae3c07853529eee99f8c40e149bf"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_h3t7s5ll0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_h3t7s5ll0();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useSvgId } from 'src/hooks/use-svg-id';
cov_h3t7s5ll0().s[0]++;
export var LogoEnGreenOnBlack = function LogoEnGreenOnBlack(_ref) {
  var _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? (cov_h3t7s5ll0().b[0][0]++, '0 0 100 40') : _ref$viewBox,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_h3t7s5ll0().f[0]++;
  var gradientId0 = (cov_h3t7s5ll0().s[1]++, useSvgId('paint0_linear_99_103'));
  var gradientId1 = (cov_h3t7s5ll0().s[2]++, useSvgId('paint1_linear_99_103'));
  var gradientId2 = (cov_h3t7s5ll0().s[3]++, useSvgId('paint2_linear_99_103'));
  var gradientId3 = (cov_h3t7s5ll0().s[4]++, useSvgId('paint3_linear_99_103'));
  var gradientId4 = (cov_h3t7s5ll0().s[5]++, useSvgId('paint4_linear_99_103'));
  var gradientId5 = (cov_h3t7s5ll0().s[6]++, useSvgId('paint5_linear_99_103'));
  var gradientId6 = (cov_h3t7s5ll0().s[7]++, useSvgId('paint6_linear_99_103'));
  var gradientId7 = (cov_h3t7s5ll0().s[8]++, useSvgId('paint7_linear_99_103'));
  cov_h3t7s5ll0().s[9]++;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: viewBox
  }, props, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2524 0H7.74757C3.46871 0 0 3.48347 0 7.78054V32.2195C0 36.5165 3.46871 40 7.74757 40H92.2524C96.5313 40 100 36.5165 100 32.2195V7.78054C100 3.48347 96.5313 0 92.2524 0Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9114 12.6892L81.5395 33.1972L81.5274 33.2434H85.7106L91.1016 12.6892H86.9114Z",
    fill: "url(#".concat(gradientId0, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4446 24.3576C19.817 24.6651 19.1268 24.8233 18.4279 24.8198C16.9206 24.8198 16.0655 24.5796 15.9731 23.3608V23.2794C15.9731 23.2301 15.967 23.1789 15.967 23.1306V19.5946L15.9731 19.1766V16.6805H15.967V15.6073L15.9731 15.1863V12.7747L12.237 13.2691C14.7672 12.7787 16.2172 10.778 16.2172 8.78643V7.56052H12.015V13.3032L11.7778 13.3695V24.0018C11.9165 26.9893 13.888 28.7648 17.1146 28.7648C18.2708 28.762 19.4145 28.5251 20.4768 28.0685L20.4979 28.0594V24.3294L20.4446 24.3576Z",
    fill: "url(#".concat(gradientId1, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1068 11.9165L9.32397 13.7333V16.7217L21.1068 14.905V11.9165Z",
    fill: "url(#".concat(gradientId2, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1068 16.2876L9.32397 18.1044V20.9582L21.1068 19.1424V16.2876Z",
    fill: "url(#".concat(gradientId3, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3286 17.6623C34.1618 14.3463 32.0878 12.3768 28.7075 12.3768C26.7651 12.3768 25.1634 13.1274 24.0762 14.5483C22.9889 15.9691 22.4202 18.0461 22.4202 20.5703C22.4202 23.0945 22.9929 25.1786 24.0762 26.5994C25.1594 28.0203 26.7651 28.7699 28.7075 28.7699C32.0878 28.7699 34.1618 26.7933 34.3286 23.4562V28.4574H38.5269V12.7265L34.3286 13.3736V17.6623ZM34.5467 20.5703C34.5467 23.5105 33.0032 25.4097 30.6147 25.4097C28.1518 25.4097 26.6817 23.6009 26.6817 20.5703C26.6817 17.5216 28.1518 15.7008 30.6147 15.7008C31.8125 15.7008 32.8133 16.1671 33.5077 17.0503C34.188 17.9135 34.5467 19.1314 34.5467 20.5703Z",
    fill: "url(#".concat(gradientId4, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.773 12.3767C47.3917 12.3767 45.3177 14.3452 45.1529 17.6672V8.14731L40.9536 8.79544V28.4523H45.1529V23.4451C45.3177 26.7862 47.3917 28.7648 50.773 28.7648C54.7301 28.7648 57.0925 25.702 57.0925 20.5702C57.0925 15.4385 54.7301 12.3767 50.773 12.3767ZM48.8638 25.4096C46.4742 25.4096 44.9308 23.5104 44.9308 20.5702C44.9308 19.1313 45.2905 17.9134 45.9708 17.0533C46.6652 16.17 47.666 15.7038 48.8638 15.7038C51.3266 15.7038 52.7967 17.5246 52.7967 20.5733C52.7998 23.6009 51.3297 25.4096 48.8668 25.4096H48.8638Z",
    fill: "url(#".concat(gradientId5, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5306 12.3767C65.1493 12.3767 63.0743 14.3452 62.9095 17.6672V8.14731L58.7113 8.79544V28.4523H62.9035V23.4451C63.0683 26.7862 65.1433 28.7648 68.5246 28.7648C72.4807 28.7648 74.8431 25.702 74.8431 20.5702C74.8431 15.4385 72.4817 12.3767 68.5306 12.3767ZM66.6214 25.4096C64.2319 25.4096 62.6885 23.5104 62.6885 20.5702C62.6885 19.1313 63.0472 17.9134 63.7275 17.0533C64.4228 16.17 65.4237 15.7038 66.6214 15.7038C69.0833 15.7038 70.5534 17.5246 70.5534 20.5733C70.5514 23.6009 69.0813 25.4096 66.6214 25.4096Z",
    fill: "url(#".concat(gradientId6, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8531 12.6892H79.3368L82.9794 28.4231H78.96L74.8531 12.6892Z",
    fill: "url(#".concat(gradientId7, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId0,
    x1: "109.695",
    y1: "17.5095",
    x2: "17.9486",
    y2: "38.9178",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId1,
    x1: "9119.63",
    y1: "-586.372",
    x2: "800.903",
    y2: "211.843",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId2,
    x1: "12217.4",
    y1: "-295.231",
    x2: "3671.05",
    y2: "4594.54",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId3,
    x1: "12329.1",
    y1: "-92.5359",
    x2: "3904.28",
    y2: "4866.67",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId4,
    x1: "17075.6",
    y1: "557.447",
    x2: "2343.15",
    y2: "3934.92",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId5,
    x1: "17178.3",
    y1: "968.097",
    x2: "2142.09",
    y2: "3714.37",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId6,
    x1: "17335.7",
    y1: "1774.04",
    x2: "2305.77",
    y2: "4518.12",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId7,
    x1: "8871.96",
    y1: "2140.23",
    x2: "1160.35",
    y2: "3069.59",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BFF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3BFFC8"
  }))));
};